import { render, staticRenderFns } from "./InfoPato.vue?vue&type=template&id=70792786&"
import script from "./InfoPato.vue?vue&type=script&lang=js&"
export * from "./InfoPato.vue?vue&type=script&lang=js&"
import style0 from "./InfoPato.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports